// Generated by scripts/login_captcha/emit.mjs; edit the TypeScript source.
import { useCallback, useEffect, useRef, useState } from 'react';
import { getLoginCaptchaConfig } from '../policies/index.js';
import { createCaptchaSession } from '../stores/session.store.js';
const config = getLoginCaptchaConfig();
export function useLoginCaptcha(active, { refreshExpired = false } = {}) {
    const [state, setState] = useState('loading');
    const [revision, setRevision] = useState(0);
    const session = useRef(null);
    const inFlight = useRef(false);
    const generation = useRef(0);
    const pending = useRef(null);
    const activeRef = useRef(active);
    activeRef.current = active;
    const retry = useCallback(() => { session.current?.dispose(); session.current = null; setState('loading'); setRevision(value => value + 1); }, []);
    useEffect(() => {
        generation.current += 1;
        if (active && config.mode === 'unavailable')
            setState('error');
        if (active && config.mode === 'required')
            session.current = createCaptchaSession(config, setState);
        return () => { session.current?.dispose(); session.current = null; pending.current?.abort(); inFlight.current = false; generation.current += 1; };
    }, [active, revision]);
    useEffect(() => { if (active && refreshExpired && state === 'expired')
        retry(); }, [active, refreshExpired, state, retry]);
    const submit = async (request) => {
        if (!active || inFlight.current || config.mode === 'unavailable')
            return null;
        const currentGeneration = generation.current;
        const controller = new AbortController();
        pending.current = controller;
        inFlight.current = true;
        let attempted = false;
        try {
            const token = config.mode === 'required' ? await session.current?.consume() : undefined;
            if (config.mode === 'required' && !token)
                return null;
            if (!activeRef.current || currentGeneration !== generation.current)
                return null;
            attempted = true;
            const result = await request(token || undefined, controller.signal);
            return activeRef.current && currentGeneration === generation.current ? result : null;
        }
        catch (error) {
            if (!activeRef.current || currentGeneration !== generation.current)
                return null;
            throw error;
        }
        finally {
            if (currentGeneration === generation.current) {
                inFlight.current = false;
                pending.current = null;
            }
            if (attempted && activeRef.current && config.mode === 'required' && currentGeneration === generation.current)
                retry();
        }
    };
    return { required: config.mode !== 'disabled', state,
        canSubmit: active && (config.mode === 'disabled' || state === 'verified'),
        retry, submit };
}
